import { common } from '@/i18n/dictionaries/common';
import { useTranslation } from '@/i18n/useTranslation';

/**
 * What a shell shows in place of a page while that page's chunk is still loading — the routes of
 * the cabinet, the administration and /harta are lazy. Its own dictionary rather than the shell's,
 * so the key resolves where it is read.
 */
export function RouteFallback() {
  const { t } = useTranslation(common);
  return <p className="empty-state">{t('loading')}</p>;
}
